import {
  aReorderInsightStatuses,
  mockReorderInsightStatusesOperationMutation,
} from '__generated__';

export const handlers = [
  mockReorderInsightStatusesOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        reorderInsightStatuses: aReorderInsightStatuses({ ok: true }),
      })
    );
  }),
];
